// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3ZfWFqoiyi5Gm19ple-Og1","right":"Wfneohd1nO1gcL48Af7TM","left":"_2YcOTHoPK2E0gPlzOMVGFZ","spin":"_1j9Cp0ZVjJ9u1gC8Qu8AyX","pulse":"_2w6rf9y3IAls9_drhK2HBc"};